"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketAssignCheckbox = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TicketAssignCheckbox = exports.TicketAssignCheckbox = function TicketAssignCheckbox(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    onReserveTicket = _ref.onReserveTicket;
  var _useState = (0, _react.useState)(checked),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsChecked(checked);
  }, [checked]);
  var handleReserveTicket = function handleReserveTicket() {
    onReserveTicket(!isChecked);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledTicketAssignCheckboxWrapper, {
    $disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: isChecked,
    disabled: disabled,
    onChange: handleReserveTicket
  }, "\u0417\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0437\u0430 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043E\u043C"), isLoading && /*#__PURE__*/_react["default"].createElement(StyledLoader, null));
};
var StyledTicketAssignCheckboxWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TicketAssignCheckbox__StyledTicketAssignCheckboxWrapper",
  componentId: "sc-129uz0-0"
})(["display:flex;align-items:center;padding:5px 0;"]);
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "TicketAssignCheckbox__StyledCheckbox",
  componentId: "sc-129uz0-1"
})(["font-size:14px;", ";cursor:", ";input{cursor:", ";}"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && 'color: #92949a;';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var StyledLoader = _styledComponents["default"].div.withConfig({
  displayName: "TicketAssignCheckbox__StyledLoader",
  componentId: "sc-129uz0-2"
})(["margin-left:auto;&:after{content:'';display:block;width:10px;height:10px;border-radius:50%;border:2px solid;border-color:#007aff transparent;animation:lds-dual-ring 1.2s linear infinite;}@keyframes lds-dual-ring{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"]);